import $ from 'jquery';

const AJAX_MARKUP_BASE_PATH = '/content/product/getMarkup/mobile';

export function preloadColorMarkup($colorOptions) {
  window.rcProps = window.rcProps || {};
  window.rcProps.colorSwatchMarkup = window.rcProps.colorSwatchMarkup || {};

  let promise = Promise.resolve();

  const codes = $colorOptions.toArray().map(el => {
    let $el = $(el);
    const useAjax = $el.data('useAjax');

    return typeof useAjax === 'undefined' || useAjax ? $el.data("code") : "";
  }).filter(code => !!code);

  loadColorMarkup(codes);
}

export function loadColorMarkup(codes) {
  let codePromise = new Promise((resolve) => {
    $.post(AJAX_MARKUP_BASE_PATH, $.param({
      codes: codes,
      d: window.rcProps.pdp.department,
    }), function(result) {
      for (const code in result) {
        window.rcProps.colorSwatchMarkup[code] = result[code];
      }
    }).always(() => {
      resolve();
    });
  });

  for (const code of codes) {
    window.rcProps.colorSwatchMarkup[code] = codePromise;
  }

  return codePromise;
}




// WEBPACK FOOTER //
// ./src/scripts/modules/preload-markup.js